import React from 'react'
import { Text } from 'pcln-design-system'
import SignInLink from './SignInLink'
import PropTypes from 'prop-types'

const SignInToSaveMore = ({ promptSignIn, isFireFly, ...props }) => {
  return (
    <Text fontSize={0} {...props}>
      <SignInLink promptSignIn={promptSignIn} />
      {isFireFly
        ? ', VIP members get an extra discount on this Express Deal!'
        : ', VIP members get an additional 5% on this Express Deal!'}
    </Text>
  )
}

SignInToSaveMore.propTypes = {
  promptSignIn: PropTypes.func,
  isFireFly: PropTypes.bool,
}

export default SignInToSaveMore
